import { useContext, useEffect } from 'react';
import LayoutDashboard from './LayoutDashboard';
import { MeContext } from '../context/MeContext';
import { useColorMode } from '@chakra-ui/react';
import { useTrackEmailCtaClick } from '../components/client/onboarding/useTrackEmailCtaClick';

const LayoutLogged = (props) => {
  const meCtx = useContext(MeContext);
  const { colorMode, toggleColorMode } = useColorMode();
  useTrackEmailCtaClick();
  useEffect(() => {
    if (meCtx && meCtx.state && meCtx.state.data) {
      const lightMode = meCtx.state.data.lightMode;
      if (lightMode && colorMode === 'dark') {
        toggleColorMode();
      }
      if (!lightMode && colorMode === 'light') {
        toggleColorMode();
      }
    }
  }, [meCtx, meCtx.state]);
  return (
    <LayoutDashboard publicPage={props.publicPage}>
      {props.children}
    </LayoutDashboard>
  );
};

export default LayoutLogged;
